var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","min-width":"100%"},on:{"click":_vm.addItemAction}},[_c('v-icon',{attrs:{"color":"#ffffff"}},[_vm._v("mdi-plus-circle-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }